// REPORTING FREQUENCY
export const GET_REPORTING_FREQUENCIES = '/reporting_frequency/query';
export const GET_REPORTING_FREQUENCY = '/reporting_frequency/';
export const POST_REPORTING_FREQUENCY = '/reporting_frequency/';
export const PUT_REPORTING_FREQUENCY = '/reporting_frequency/';
export const DELETE_REPORTING_FREQUENCY = '/reporting_frequency/';
export const CHECK_REPORTING_FREQUENCY_EXISTS = '/reporting_frequency/query';
